import { constructEnum } from '@/lib/enum';

export default constructEnum('PriceRange', {
  RANGE10: 10,
  RANGE20: 20,
  RANGE30: 30,
  RANGE40: 40,
  RANGE50: 50
});
